import { realApi } from './api';

// /jugadores/:id es la ficha de una persona; el listado por temporada usa un
// endpoint aparte (no hay "todos los jugadores" sin filtrar por temporada).
export const getJugadorReal = (id) => realApi.get(`/jugadores/${id}`).then((r) => r.datos);

export const getJugadoresTemporadaReal = (temporadaId) =>
  realApi.get(`/temporadas/${encodeURIComponent(temporadaId)}/jugadores?porPagina=200`).then((r) => r.datos);

// Ranking del jugador sumando todas las temporadas en las que ha jugado
// (v_ranking_jugadores es siempre por temporada; esto lo agrega en el backend).
export const getRankingTotalJugadorReal = (id) =>
  realApi.get(`/jugadores/${id}/ranking-total`).then((r) => r.datos);

// Catálogo global (sin filtrar por temporada), para fichar a alguien que
// todavía no está inscrito. Solo ADMIN/COMITE.
export const buscarJugadoresGlobal = (buscar) => {
  const params = new URLSearchParams({ porPagina: '200' });
  if (buscar) params.set('buscar', buscar);
  return realApi.get(`/jugadores?${params}`).then((r) => r.datos);
};

export const crearJugadorReal = (datos) =>
  realApi.post('/jugadores', datos).then((r) => r.datos);

export const actualizarJugadorReal = (id, datos) =>
  realApi.patch(`/jugadores/${id}`, datos);

// Puntos de competiciones fuera de la liga (Copa, Campeonato de España...):
// un valor final por jugador y temporada, sin partidos. Lectura pública;
// alta/edición/baja solo ADMIN/COMITE (ver 06_otras_competiciones.sql /
// 07_otros_resultados_temporada.sql). Filtrado por la temporada
// seleccionada, igual que el resto de la ficha.
export const getOtrosResultadosReal = (jugadorId, temporadaId) =>
  realApi
    .get(`/jugadores/${jugadorId}/otros-resultados?temporada=${encodeURIComponent(temporadaId)}`)
    .then((r) => r.datos);

export const crearOtroResultadoReal = (jugadorId, datos) =>
  realApi.post(`/jugadores/${jugadorId}/otros-resultados`, datos);

export const actualizarOtroResultadoReal = (id, datos) =>
  realApi.patch(`/otros-resultados/${id}`, datos);

export const borrarOtroResultadoReal = (id) =>
  realApi.delete(`/otros-resultados/${id}`);

// Correo de prueba ("Verificación del correo") al correo guardado del jugador.
// Solo ADMIN (el backend responde 403 al resto). La dirección la lee el
// servidor de la base de datos: aquí solo se manda el id del jugador.
export const enviarCorreoPrueba = (id) =>
  realApi.post(`/jugadores/${id}/correo-prueba`).then((r) => r.datos);

// Histórico de correos de un jugador, del más reciente al más antiguo:
// avisos automáticos y correos de prueba (AL_JUGADOR) y solicitudes de
// revisión que él mandó (DEL_JUGADOR). Solo ADMIN/COMITE.
export const getHistorialEnvios = (id) =>
  realApi.get(`/jugadores/${id}/envios`).then((r) => r.datos);
